import { render, staticRenderFns } from "./CustomPinRulesAccordion.vue?vue&type=template&id=280cd0bd&scoped=true&"
import script from "./CustomPinRulesAccordion.vue?vue&type=script&lang=js&"
export * from "./CustomPinRulesAccordion.vue?vue&type=script&lang=js&"
import style0 from "./CustomPinRulesAccordion.vue?vue&type=style&index=0&id=280cd0bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280cd0bd",
  null
  
)

export default component.exports